import MvCheckBox from 'Generic/MvCheckBox';
import MvwIcon from 'Generic/MvIcon/MvIcon';
import React, { useState } from 'react';
import "./styles.sass"
import {
    TransactionFilters,
    UsageTransactionFilters,
} from './types';

export interface Props {
    heading: string;
    filters: Array<string|number>;
    onFilterChange: (selection: string|number) => void;
    selected: Array<string|number>;
};

/**
 * TODO: Describe this component!
 */
const FilterSection = ({
    heading,
    filters,
    onFilterChange,
    selected,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <fieldset className='filter-section'>
            <button 
                className='filter-section-trigger-btn'
                onClick={() => setIsOpen(!isOpen)}
            >
                <legend>{heading}</legend>
                <MvwIcon
                    height='10px'
                    width='10px'
                    icon={isOpen ? 'minus' : 'plus'}
                    color='#929292'
                />
            </button>
            {isOpen &&
                <div className='checkboxes-container'>
                    {filters.map(filter => (
                        <MvCheckBox
                            label={filter as string}
                            onChange={() => onFilterChange(filter)}
                            checked={selected.includes(filter as never)}
                            id={`${heading}-${filter}`}
                        />
                    ))}
                </div>
            }
        </fieldset>
    );
};

export {
    FilterSection,
};
